import uuidv4 from "uuid/v4";

export default function createNotificationService(jokiInstance) {
    const serviceId = "NotificationService";
    const joki = jokiInstance;

    const notifications = new Map();

    function eventHandler(event) {
        
        switch (event.key) {
            case "newNotification":
                newNotification(event.body);
                break;
            case "closeNotification":
            case "clearNotification":
                clearNotification(event.body !== undefined ? event.body : null);
                break;
            case "clearAllNotifications":
                clearNotification();
                break;
            case "readNotification":
                readNotification(event.body !== undefined ? event.body : null);
                break;
            case "getState":
            case "getNotifications":
                return getNotification(null);
            case "getNotification":
                return getNotification(event.body);
            case "initialize":
                // newNotification({
                //     level: "NOTICE",
                //     text: "Welcome to IPA Admin Portal"
                // });
                break;
            default:
                break;
        }
    }

    function getNotification(notificationId = null) {
        // console.log(serviceId+":getNotification", notificationId);
        if (notificationId === null) {
            return Array.from(notifications.values());
        }
        if (notifications.has(notificationId)) {
            return notifications.get(notificationId);
        }
        return null;
    }

    function newNotification(notificationData) {
        // console.log("new notification", notificationData);
        const same = _identicalNotificationExists(notificationData);
        if(same !== false) {
            same.counter++;
            same.read = false;
            return _updateNotification(same.id, same);
        }
        const note = Object.assign(
            {},
            {
                id: uuidv4(),
                level: "notice",
                text: "WARNING NO TEXT ON NOTIFICATION",
                read: false,
                closed: false,
                from: null,
                time: Date.now(),
                readTime: null,
                closeTime: null,
                counter: 0
            },
            notificationData
        );
        note.level = note.level.toLowerCase();
        notifications.set(note.id, note);
        // console.log("notifications", notifications);
        _triggerNotificationUpdate();
    }

    function readNotification(notificationId) {
        if (notificationId === null) {
            notifications.forEach((note, id) => {
                _updateNotification(id, { read: true, readTime: Date.now() });
            });
        } else {
            _updateNotification(notificationId, { read: true, readTime: Date.now() });
        }
        _triggerNotificationUpdate();
    }

    function clearNotification(notificationId = null) {
        if (notificationId === null) {
            notifications.forEach((note, id) => {
                _updateNotification(id, { closed: true, closeTime: Date.now() });
            });
        } else {
            _updateNotification(notificationId, { closed: true, closeTime: Date.now() });
        }
        _triggerNotificationUpdate();
    }

    function _identicalNotificationExists(notfData) {
        let hasTheSameNotification = false;
        (notfData && notfData.level) ? (notfData.level = notfData.level.toLowerCase()) : notfData.level = "";
        notifications.forEach((val, key) => {
            if(val.text === notfData.text && val.level === notfData.level) {
                if(val.level === "info") {
                    hasTheSameNotification = val;    
                } else {
                    if(val.closed !== true) {
                        hasTheSameNotification = val;
                    }
                }
                
            }
        });
        
        return hasTheSameNotification;
    }

    function _updateNotification(id, data) {
        if (notifications.has(id)) {
            const note = Object.assign({}, notifications.get(id), data);
            notifications.set(id, note);
        }
    }

    function _triggerNotificationUpdate() {
        joki.trigger({
            from: serviceId,
            key: "notificationsUpdated",
            serviceUpdate: true,
            body: Array.from(notifications.values())
        });
    }

    joki.addService({
        id: serviceId,
        fn: eventHandler,
    });
}
